import axios from "axios";

// Se importa una sola vez (en index.js), y parcha tanto "axios" como el
// "fetch" nativo del navegador para que TODA petición de la app lleve el
// token de sesión — sin tener que tocar cada componente uno por uno.
// Algunos componentes viejos usan fetch() en vez de axios, así que hay
// que cubrir los dos.

let yaCerrandoSesion = false;

function cerrarSesionPorTokenInvalido() {
  if (yaCerrandoSesion) return;
  yaCerrandoSesion = true;
  localStorage.removeItem("usuario");
  localStorage.removeItem("token");
  window.location.reload();
}

/* =========================================
   AXIOS
========================================= */
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      cerrarSesionPorTokenInvalido();
    }
    return Promise.reject(error);
  }
);

/* =========================================
   FETCH NATIVO
========================================= */
const fetchOriginal = window.fetch.bind(window);

window.fetch = async (input, init = {}) => {
  const token = localStorage.getItem("token");

  const headers = new Headers(init.headers || {});
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const respuesta = await fetchOriginal(input, { ...init, headers });

  if (respuesta.status === 401) {
    cerrarSesionPorTokenInvalido();
  }

  return respuesta;
};
